import { useState, useEffect } from 'react'
import { Header } from '../components/layout/Header'

const API_BASE = '/api'

export default function CostCalculatorPage() {
  const [templates, setTemplates] = useState<{id: string; name: string; description: string}[]>([])
  const [statistics, setStatistics] = useState<{total_calculations: number; templates: number; avg_roi: number} | null>(null)
  const [selectedMarket, setSelectedMarket] = useState('DE')
  const [result, setResult] = useState<any>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    const [templatesRes, statsRes] = await Promise.all([
      fetch(API_BASE + '/cost-calculator/templates'),
      fetch(API_BASE + '/cost-calculator/statistics')
    ])
    if (templatesRes.ok) setTemplates((await templatesRes.json()).templates || [])
    if (statsRes.ok) setStatistics(await statsRes.json())
  }

  const calculate = async () => {
    setLoading(true)
    const res = await fetch(API_BASE + '/cost-calculator/market-entry', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ market: selectedMarket, params: {} })
    })
    if (res.ok) setResult(await res.json())
    setLoading(false)
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">Cost Calculator & ROI Analysis</h1>
        {statistics && (
          <div className="grid grid-cols-3 gap-6 mb-8">
            <div className="bg-white rounded-lg shadow p-6"><div className="text-sm text-gray-500">Total Calculations</div><div className="text-3xl font-bold">{statistics.total_calculations}</div></div>
            <div className="bg-white rounded-lg shadow p-6"><div className="text-sm text-gray-500">Templates</div><div className="text-3xl font-bold">{statistics.templates}</div></div>
            <div className="bg-white rounded-lg shadow p-6"><div className="text-sm text-gray-500">Avg ROI</div><div className="text-3xl font-bold text-green-600">{statistics.avg_roi}%</div></div>
          </div>
        )}
        <div className="grid grid-cols-2 gap-8">
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold mb-4">Market Entry Calculator</h2>
            <select value={selectedMarket} onChange={e => setSelectedMarket(e.target.value)} className="w-full px-4 py-2 border rounded-lg mb-4">
              <option value="DE">Germany</option>
              <option value="FR">France</option>
              <option value="ES">Spain</option>
              <option value="IT">Italy</option>
              <option value="NL">Netherlands</option>
            </select>
            <button onClick={calculate} disabled={loading} className="w-full py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">{loading ? 'Calculating...' : 'Calculate'}</button>
          </div>
          {result && (
            <div className="bg-white rounded-lg shadow p-6">
              <h2 className="text-xl font-semibold mb-4">Results for {result.market}</h2>
              <div className="space-y-4">
                <div><div className="text-sm text-gray-500">Total Cost</div><div className="text-2xl font-bold">${result.costs.total.toLocaleString()}</div></div>
                <div><div className="text-sm text-gray-500">Expected Revenue</div><div className="text-2xl font-bold text-green-600">${result.roi.expected_revenue.toLocaleString()}</div></div>
                <div><div className="text-sm text-gray-500">Break Even</div><div className="text-xl font-bold">{result.roi.break_even_months} months</div></div>
                <div><div className="text-sm text-gray-500">ROI</div><div className="text-xl font-bold text-green-600">{result.roi.roi_percentage.toFixed(1)}%</div></div>
              </div>
            </div>
          )}
        </div>
        <div className="mt-8">
          <h2 className="text-xl font-semibold mb-4">Templates</h2>
          <div className="grid grid-cols-3 gap-4">
            {templates.map(t => (
              <div key={t.id} className="bg-white rounded-lg shadow p-4">
                <h3 className="font-semibold">{t.name}</h3>
                <p className="text-sm text-gray-500">{t.description}</p>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  )
}
